//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/SectionList.js";
import "../no/ObjectList.js";
let d=[[[1,"CurveBoundaries",0,"SectionList",0],[0,"DistanceTolerance",1,0],[0,"SelectionType",1,0]],[[[],"GetView",{R_:{view:"View"}},0,0],[["view"],"SetView",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.BoundaryBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.BoundaryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.BoundaryBuilder.SelectionMethod = Object.freeze({
    "Curves" : "Curves", "Location" : "Location"});

export default SPLM;